"use client";

import { createContext, useContext, useMemo, type ReactNode } from "react";
import { type EcolabArticle } from "types/ContentHub/Article";

export type ArticleContextProps = {
  article?: EcolabArticle;
  articleSlug: string;
};

const ArticleContext = createContext<ArticleContextProps>({
  article: undefined,
  articleSlug: "",
});

interface ArticleProviderProps {
  children: ReactNode;
  article?: EcolabArticle;
  articleSlug: string;
}

export const ArticleProvider = ({
  children,
  article,
  articleSlug,
}: ArticleProviderProps) => {
  const contextValue = useMemo(
    () => ({ article, articleSlug }),
    [article, articleSlug],
  );
  return (
    <ArticleContext.Provider value={contextValue}>
      {children}
    </ArticleContext.Provider>
  );
};

export const useArticleContext = (): ArticleContextProps =>
  useContext(ArticleContext);
